// Metrics.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getMetrics } from '../../common/api/MetricsAPIHelper';
import { updateMetricsForPortco } from '../../common/api/PortcoMetricsAPIHelper';
import './metrics.css';
import "../../common/css/protagonistForm.css";


const Metrics = ({portcoId}) => {
  const [metrics, setMetrics] = useState([]);
  const [metricValues, setMetricValues] = useState({});
  const [formKey, setFormKey] = useState(0);
  const [snackbar, setSnackbar] = useState({open: false, message: '', severity: 'success'});

  const user = useSelector((state) => state.user);



  useEffect(() => {
    const fetchMetrics = async () => {
      const data = await getMetrics();
      setMetrics(data.filter(metric => !metric.hidden_metric));
    };
    fetchMetrics();
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();
  
    const metricsToUpdate = Object.keys(metricValues).map(metricId => {
      let metricToUpdate = {
        "portco_id": parseInt(portcoId),
        "metric_id": parseInt(metricId),
        "metric_value": parseFloat(metricValues[metricId].value),
        "metric_reported_by_user_id": 1,
        "metric_reported_by_email": user.email
      };
      
      if(metricValues[metricId].date) {
        metricToUpdate.metric_date = metricValues[metricId].date;
      }
      
      return metricToUpdate;
    });

    try {
      await updateMetricsForPortco(metricsToUpdate);
      setSnackbar({open: true, message: 'Metrics updated successfully.', severity: 'success'});
    } catch (error) {
      setSnackbar({open: true, message: 'Failed to update metrics.', severity: 'error'});
    }
    setMetricValues({});
    setFormKey(prevKey => prevKey + 1); // Resets the input fields
  };
  

  const handleClear = () => {
    setMetricValues({});
  };

  const handleInputChange = (event, date=false) => {
    const metricId = event.target.name;
    let value;
    if(date) {
      value = event.target.value;
    } else {
      value = event.target.value.toUpperCase();
      let numberValue;
      
      if (value.endsWith('M')) {
        numberValue = parseInt(value) * 1000000;
      } else if (value.endsWith('K')) {
        numberValue = parseInt(value) * 1000;
      } else {
        numberValue = parseInt(value);
      }

      value = numberValue;
    }

    setMetricValues(prevValues => ({
      ...prevValues,
      [metricId]: { 
        ...prevValues[metricId], 
        [date ? 'date' : 'value']: value 
      }
    }));
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prevSnackbar => ({ ...prevSnackbar, open: false }));
  };



  return (
    <div className="form_container">
      <form key={formKey} onSubmit={handleSubmit}>
      <div className="table_wrapper">
        <table className="metrics_table">
          <thead>
            <tr>
              <th>Metric Name</th>
              <th>Metric Value</th>
              <th>Metric Date</th>
            </tr>
          </thead>
          <tbody>
            {metrics.map((metric) => (
              <tr key={metric.metric_id}>
                <td>{metric.metric_name}</td>
                <td>
                  <input 
                    type="text" 
                    name={metric.metric_id}
                    onChange={handleInputChange} 
                    className="metric-input" />
                </td>
                <td>
                    <input
                      type="date"
                      name={metric.metric_id}
                      onChange={(e) => handleInputChange(e, true)}
                      className="metric-input" />
                  </td>
              </tr>
            ))}
            <tr>
              <td colSpan={3}>
                <div className="buttons">
                  <button type="submit" className="ra__protAdminform_button" >Save</button>
                  <button type="button" className="ra__protAdminform_button" onClick={handleClear}>Clear</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </form>
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );

};

export default Metrics;
